// Domain-scoped API modules assembled into the financeApi facade used across the app.
export {
  api,
  ApiError,
  isGroupAccessBlocked,
  isSupportView,
  startSupportView,
  stopSupportView,
  SUPPORT_VIEW_GROUP_KEY,
  SUPPORT_VIEW_READONLY_MESSAGE,
} from "./core";
import { accountsApi } from "./accounts";
import { authApi } from "./auth";
import { categoriesApi } from "./categories";
import { currenciesApi } from "./currencies";
import { feedbackApi } from "./feedback";
import { groupsApi } from "./groups";
import { importsApi } from "./imports";
import { linkedTransactionsApi } from "./linkedTransactions";
import { mcpTokensApi } from "./mcpTokens";
import { overviewApi } from "./overview";
import { recurringPaymentsApi } from "./recurringPayments";
import { reportsApi } from "./reports";
import { tagsApi } from "./tags";
import { transactionsApi } from "./transactions";
import { tipsApi } from "./tips";

export const financeApi = {
  ...authApi,
  ...groupsApi,
  ...accountsApi,
  ...categoriesApi,
  ...tagsApi,
  ...currenciesApi,
  ...transactionsApi,
  ...linkedTransactionsApi,
  ...recurringPaymentsApi,
  ...overviewApi,
  ...reportsApi,
  ...importsApi,
  ...feedbackApi,
  ...mcpTokensApi,
  ...tipsApi,
};
